import { ScreenElement, Engine, vec, Canvas } from "excalibur";
import { MatrixShader } from "./shaders/matrix";

export class Background extends ScreenElement {
  constructor() {
    super({
      name: 'Background',
      pos: vec(0, 0),
    });
  }

  override onInitialize(engine: Engine) {

    const canvas = new Canvas({
      width: engine.screen.canvasWidth,
      height: engine.screen.canvasHeight,
      cache: true,
    })

    this.graphics.add(canvas);

    const material = new MatrixShader().create();
    this.graphics.material = material;

    this.z = -100;


    engine.input.pointers.primary.on('move', function (evt) {
      material.update(shader => {
        shader.trySetUniformFloatVector('u_mouse', evt.worldPos);
      });
    });
  }

}
